import type { IPropertyBag } from '@deity-io/di-data-basics';
import { Box, Input } from '@deity-io/portal-ui';
import type { FC } from 'react';
import type { IContainerChildrenProps } from 'utils';
import type { IEditGridColumnProps } from './EditGridColumn';

const RequestParamsEditCell: FC<
  {
    column: IEditGridColumnProps;
    inEdit?: boolean;
    onToggleEdit?: (editOn: boolean) => void;
    onChange?: (value: string) => void;
    value: string | number | undefined;
  } & IContainerChildrenProps
> = ({ onToggleEdit, value, inEdit, onChange, column }) => {
  const css: IPropertyBag = {
    overflow: 'hidden'
  };
  if (value === undefined) {
    css['color'] = 'gray';
  }

  return (
    <Box
      style={css}
      onClick={() => {
        if (onToggleEdit) {
          onToggleEdit(true);
        }
      }}
    >
      {inEdit ? (
        <Input
          fullWidth
          autoFocus
          size="small"
          type="text"
          value={value || ''}
          onChange={e => {
            if (onChange) {
              onChange(e.target.value);
            }
          }}
          onBlur={() => {
            if (onToggleEdit) {
              onToggleEdit(false);
            }
          }}
        />
      ) : (
        value || column.placeholder || '&nbsp'
      )}
    </Box>
  );
};

export default RequestParamsEditCell;
